import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #d6d6d6;
  height: 80vh;

  @media (max-width: 900px) {
  }
`;

export const Text = styled.p`
  display: flex;
  text-transform: uppercase;
  font-size: 22px;

  @media (max-width: 900px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const BoldText = styled.p`
  font-weight: bolder;
`;

export const LightText = styled.p`
  font-size: 18px;
`;
